// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"82c63f7e","54":"134d42cc","168":"463a5086","173":"a7fa1d0e","371":"cb715c8a","441":"38b9b60a","461":"e7a982af","470":"04c98ae0","756":"98336127"}[chunkId] + ".chunk.css";
};